import WizardRedirectContext from "@/components/wizard-redirect-context";
import { useContext } from "react";

const useWizardCanRedirect = () => {
  const { canRedirect, setCanRedirect } = useContext(WizardRedirectContext);
  return [canRedirect, setCanRedirect] as const;
};

export default useWizardCanRedirect;
